import { useEffect} from "react"
import { useDocumentTitle } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { device } from "../../lib/constants";
import { ChevronLeft } from "lucide-react";
import { Card } from "@mantine/core";
import { useParams, Link } from "react-router-dom";
import TaskActions from "@/components/workflow/Actions";
import CompanyDetails from "@/components/workflow/CompanyDetails";
import TabContainer from "@/components/workflow/TabContainer";
import { useAccessRequest } from "@/context/access-request-context";

const Wrapper = styled.div`
  padding: 40px 64px 0 64px;
  @media ${device.tablet} {
    padding: 40px 16px 0 16px;
  }
`;

const RequestDetails = () => {
	const { t } = useTranslation();
	useDocumentTitle(`DAP: ${t("navigation.requests")}`);

	const { requestId } = useParams<{ requestId: string }>();
	const { fetchComments, fetchTaskHistory, fetchTasks } = useAccessRequest();

	const tabs = [
		{ id: "application_tracker", label: "Application Tracker" },
		{ id: "comments", label: "Comments / Notes" },
	];

  useEffect(() => {
    fetchTasks(requestId)
    fetchComments({ requestId });
		fetchTaskHistory(requestId);
	}, [fetchComments, fetchTaskHistory,fetchTasks, requestId]);

	return (
			<Wrapper>
				<RequestsArea>
					<div className="text-gray-100">
						<div className="flex items-center justify-between mb-6">
							<div className="flex items-center gap-2">
								<Link to="/requests">
									<button
										type="button"
										className="text-gray-400 hover:text-gray-300 transition-colors"
									>
										<ChevronLeft />
									</button>
								</Link>

								<span className="text-[20px] text-textColor">
									Request ID: {requestId}
								</span>
							</div>
							<div className="flex gap-2">
								<TaskActions />
							</div>
						</div>
						<Card className="border border-[#3F5064] bg-accentBg mb-6 rounded-[6px]">
							<CompanyDetails />
						</Card>
						{/* Tabs */}
						<TabContainer tabs={tabs} />
					</div>
				</RequestsArea>
			</Wrapper>
	);
}

const RequestsArea = styled.div`
  margin-top: 5px;
`;

export default RequestDetails